import PropTypes from "prop-types";
import React from "react";

import { getAutomationDataAttr } from "../../../utils/automationUtils";
import { ICON_SIZES, ICON_TYPES } from "../../../constants/icons";
import images from "../../../utils/images";

const SettingsList = (props) => {
  const { iconComponent: IconComponent, text, ...domProps } = props;
  let automationDataAttrName;

  if (text && typeof text === "string") {
    automationDataAttrName = `Setting${text.replaceAll(" ", "")}`;
  }

  return (
    <div
      className="Settings__list fs-16 fs-md-14 px-0 px-md-3 d-flex cursor justify-content-between align-items-center"
      data-public="true"
      {...domProps}
    >
      <div className="my-3 py-2">
        {IconComponent && (
          <IconComponent
            className="Settings__iconComponent"
            iconSize={ICON_SIZES.SMALL}
            iconType={ICON_TYPES.OUTLINE}
          />
        )}

        <p
          className="d-inline-block m-0 Settings__icon-text"
          {...getAutomationDataAttr(automationDataAttrName)}
        >
          {text}
        </p>
      </div>
      <div>
        <img alt="Right Arrow" src={images("./common/settings_right.svg")} />
      </div>
    </div>
  );
};

SettingsList.propTypes = {
  iconComponent: PropTypes.func,
  text: PropTypes.string,
};
export default SettingsList;
